
{
  "familyId": "MET-COORDINATEN",
  "questions": [
    {
      "id": "MET-COORDINATEN-001",
      "familyId": "MET-COORDINATEN",
      "module": "Metriek",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "figuren",
      "subSkill": "coordinaten_assenstelsel",
      "questionType": "multiple_choice",
      "question": "Een cartograaf plaatst punten op een kaart. Welk punt heeft de coördinaten (3, 5)?",
      "context": "In een assenstelsel staan vier punten: A = (3, 5), B = (5, 3), C = (3, 3), D = (5, 5).",
      "options": ["Punt A", "Punt B", "Punt C", "Punt D"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "coordinateGrid",
          "data": {
            "width": 7,
            "height": 7,
            "showGrid": true,
            "points": [
              { "x": 3, "y": 5, "label": "A" },
              { "x": 5, "y": 3, "label": "B" },
              { "x": 3, "y": 3, "label": "C" },
              { "x": 5, "y": 5, "label": "D" }
            ],
            "label": "Assenstelsel met punten A, B, C, D"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Coördinaten lezen",
            "content": "Bij coördinaten (x, y) ga je eerst naar rechts (x-as) en dan omhoog (y-as). (3, 5) = 3 naar rechts, 5 omhoog.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "coordinates_identify_point",
      "variantIndex": 1,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "Bij coördinaten (x, y) ga je eerst langs de x-as (horizontaal) en dan langs de y-as (verticaal). x = 3 → ga 3 naar rechts. y = 5 → ga 5 omhoog. Dat is punt A. Onthoud: eerst de x (naar rechts), dan de y (omhoog).",
        "solutionSteps": [
          "x = 3 → ga 3 naar rechts",
          "y = 5 → ga 5 omhoog",
          "Dat is punt A"
        ],
        "distractorExplanations": {
          "0": "Goed! (3, 5) = 3 naar rechts, 5 omhoog = punt A.",
          "1": "Je hebt waarschijnlijk x en y omgedraaid. Punt B = (5, 3), niet (3, 5). Onthoud: bij (3, 5) ga je eerst 3 naar rechts, dan 5 omhoog — niet andersom.",
          "2": "Je hebt waarschijnlijk de y-coördinaat verkeerd gelezen. Punt C = (3, 3), terwijl (3, 5) een y van 5 heeft. Onthoud: het tweede getal is de y-coördinaat (omhoog).",
          "3": "Je hebt waarschijnlijk de x-coördinaat verkeerd gelezen. Punt D = (5, 5), terwijl (3, 5) een x van 3 heeft. Onthoud: het eerste getal is de x-coördinaat (naar rechts)."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "met.coord-xy-omgedraaid", "label": "x en y omgedraaid", "optionIndex": 1 },
          { "id": "met.coord-y-als-x-gelezen", "label": "y verkeerd gelezen", "optionIndex": 2 },
          { "id": "met.coord-x-als-y-gelezen", "label": "x verkeerd gelezen", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "MET-COORDINATEN-002",
      "familyId": "MET-COORDINATEN",
      "module": "Metriek",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "figuren",
      "subSkill": "coordinaten_assenstelsel",
      "questionType": "multiple_choice",
      "question": "Een game-ontwerper plaatst punt P op (4, 2). Punt Q staat 3 hokjes naar rechts en 1 hokje omhoog. Wat zijn de coördinaten van Q?",
      "context": null,
      "options": ["(4, 5)", "(1, 1)", "(7, 3)", "(7, 2)"],
      "correctAnswer": 2,
      "stimulusAids": [
        {
          "type": "coordinateGrid",
          "data": {
            "width": 9,
            "height": 6,
            "showGrid": true,
            "points": [{ "x": 4, "y": 2, "label": "P" }],
            "label": "Assenstelsel met punt P"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Coördinaten verschuiven",
            "content": "Naar rechts = x wordt groter. Omhoog = y wordt groter. P = (4, 2). 3 naar rechts: x = 4 + 3 = 7. 1 omhoog: y = 2 + 1 = 3.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "coordinates_translate",
      "variantIndex": 2,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "Tel de verschuiving op bij de coördinaten. P = (4, 2). 3 naar rechts → x = 4 + 3 = 7. 1 omhoog → y = 2 + 1 = 3. Q = (7, 3). Onthoud: naar rechts = x groter, omhoog = y groter.",
        "solutionSteps": [
          "P = (4, 2)",
          "3 naar rechts: x = 4 + 3 = 7",
          "1 omhoog: y = 2 + 1 = 3",
          "Q = (7, 3)"
        ],
        "distractorExplanations": {
          "0": "Je hebt waarschijnlijk alleen de y-coördinaat veranderd. Maar 3 naar rechts verandert óók de x: 4 + 3 = 7. Onthoud: bij verschuiving veranderen beide coördinaten als er beweging in beide richtingen is.",
          "1": "Je hebt waarschijnlijk de richting omgedraaid en afgetrokken. Maar naar rechts = x groter, omhoog = y groter. (4 − 3, 2 − 1) = (1, 1) zou naar links én omlaag zijn.",
          "2": "Goed! (4 + 3, 2 + 1) = (7, 3).",
          "3": "Je bent waarschijnlijk vergeten omhoog te verschuiven. y = 2 + 1 = 3, niet 2. Onthoud: 1 omhoog verandert ook de y-coördinaat."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "met.coord-translatie-x-vergeten", "label": "x-verandering vergeten", "optionIndex": 0 },
          { "id": "met.coord-translatie-aftrekken", "label": "Aftrekken i.p.v. optellen", "optionIndex": 1 },
          { "id": "met.coord-translatie-y-vergeten", "label": "y-verandering vergeten", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "MET-COORDINATEN-003",
      "familyId": "MET-COORDINATEN",
      "module": "Metriek",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "figuren",
      "subSkill": "coordinaten_assenstelsel",
      "questionType": "multiple_choice",
      "question": "Welke coördinaten horen bij de oorsprong van het assenstelsel?",
      "context": null,
      "options": ["(1, 1)", "(0, 0)", "(0, 1)", "(1, 0)"],
      "correctAnswer": 1,
      "stimulusAids": [
        {
          "type": "coordinateGrid",
          "data": {
            "width": 5,
            "height": 5,
            "showGrid": true,
            "points": [],
            "label": "Leeg assenstelsel — waar is de oorsprong?"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Oorsprong",
            "content": "De oorsprong is het punt waar de x-as en y-as elkaar kruisen. Dat is altijd (0, 0) — nul naar rechts, nul omhoog.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "coordinates_origin",
      "variantIndex": 3,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "De oorsprong is het snijpunt van de x-as en y-as. Beide assen beginnen bij 0, dus de oorsprong = (0, 0). Onthoud: oorsprong = startpunt = (0, 0). Bij elke andere keuze sta je al een stap weg van het kruispunt.",
        "solutionSteps": [
          "De oorsprong is waar de x-as en y-as kruisen",
          "x = 0 en y = 0",
          "Oorsprong = (0, 0)"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat het assenstelsel bij (1, 1) begint. Maar (1, 1) ligt al één hokje rechts én één hokje omhoog van de oorsprong. Onthoud: de oorsprong is altijd (0, 0).",
          "1": "Goed! De oorsprong = (0, 0).",
          "2": "(0, 1) ligt op de y-as, één hokje boven de oorsprong. Bij de oorsprong zijn beide coördinaten 0. Onthoud: óók de y moet 0 zijn.",
          "3": "(1, 0) ligt op de x-as, één hokje rechts van de oorsprong. Bij de oorsprong zijn beide coördinaten 0. Onthoud: óók de x moet 0 zijn."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "met.coord-oorsprong-een-een", "label": "Oorsprong als (1,1)", "optionIndex": 0 },
          { "id": "met.coord-oorsprong-op-as", "label": "Oorsprong op y-as", "optionIndex": 2 },
          { "id": "met.coord-oorsprong-op-as", "label": "Oorsprong op x-as", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "MET-COORDINATEN-004",
      "familyId": "MET-COORDINATEN",
      "module": "Metriek",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "figuren",
      "subSkill": "coordinaten_assenstelsel",
      "questionType": "multiple_choice",
      "question": "Een architect tekent een rechthoek. Drie hoekpunten zijn: A(1, 1), B(1, 4) en C(6, 1). Wat is het vierde hoekpunt D?",
      "context": null,
      "options": ["(4, 4)", "(4, 6)", "(6, 6)", "(6, 4)"],
      "correctAnswer": 3,
      "stimulusAids": [
        {
          "type": "coordinateGrid",
          "data": {
            "width": 8,
            "height": 6,
            "showGrid": true,
            "points": [
              { "x": 1, "y": 1, "label": "A" },
              { "x": 1, "y": 4, "label": "B" },
              { "x": 6, "y": 1, "label": "C" }
            ],
            "label": "Rechthoek met 3 hoekpunten gegeven"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Vierde hoekpunt vinden",
            "content": "Een rechthoek heeft tegenoverliggende zijden die gelijk zijn. Het vierde punt deelt zijn x met C en zijn y met B.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "coordinates_rectangle_vertex",
      "variantIndex": 4,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "In een rechthoek staan tegenover elkaar liggende zijden evenwijdig. Het vierde hoekpunt D deelt coördinaten met twee andere punten: dezelfde x als C (6) en dezelfde y als B (4). Dus D = (6, 4). Controleer: A(1,1), B(1,4), C(6,1), D(6,4) vormen samen een rechthoek met breedte 5 en hoogte 3 ✓.",
        "solutionSteps": [
          "Punt C heeft x = 6 → D moet ook x = 6 hebben (rechterzijde)",
          "Punt B heeft y = 4 → D moet ook y = 4 hebben (bovenkant)",
          "D = (6, 4)",
          "Controleer: vier hoeken vormen een rechthoek ✓"
        ],
        "distractorExplanations": {
          "0": "x = 4 hoort bij geen van de gegeven hoekpunten. De x van D moet gelijk zijn aan de x van C (= 6), anders ontstaat geen rechthoek. Onthoud: het vierde hoekpunt deelt coördinaten met twee bestaande hoekpunten.",
          "1": "Je hebt x en y omgedraaid: (4, 6) i.p.v. (6, 4). Onthoud: x komt eerst (van punt C → 6), dan y (van punt B → 4).",
          "2": "y = 6 hoort bij geen van de gegeven hoekpunten. De y van D moet gelijk zijn aan de y van B (= 4). Onthoud: het vierde hoekpunt deelt coördinaten met de andere drie.",
          "3": "Goed! Het vierde hoekpunt is D = (6, 4) — x van C, y van B."
        }
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "met.coord-rechthoek-x-fout", "label": "Verkeerde x", "optionIndex": 0 },
          { "id": "met.coord-xy-omgedraaid", "label": "x en y omgedraaid", "optionIndex": 1 },
          { "id": "met.coord-rechthoek-y-fout", "label": "Verkeerde y", "optionIndex": 2 }
        ]
      }
    },
    {
      "id": "MET-COORDINATEN-005",
      "familyId": "MET-COORDINATEN",
      "module": "Metriek",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "figuren",
      "subSkill": "coordinaten_assenstelsel",
      "questionType": "multiple_choice",
      "question": "Een landmeter meet de afstand tussen punt A(2, 3) en punt B(2, 8). Hoe groot is de afstand?",
      "context": null,
      "options": ["6", "11", "5", "3"],
      "correctAnswer": 2,
      "stimulusAids": [
        {
          "type": "coordinateGrid",
          "data": {
            "width": 6,
            "height": 10,
            "showGrid": true,
            "points": [
              { "x": 2, "y": 3, "label": "A" },
              { "x": 2, "y": 8, "label": "B" }
            ],
            "label": "Punten A en B op dezelfde verticale lijn"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Afstand op één as",
            "content": "Als twee punten dezelfde x-coördinaat hebben, staan ze op dezelfde verticale lijn. De afstand is dan het verschil van de y-coördinaten: |8 − 3| = 5.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "coordinates_distance_vertical",
      "variantIndex": 5,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.77,
      "feedback": {
        "explanationText": "Als twee punten dezelfde x-coördinaat hebben, staan ze op één verticale lijn. De afstand is dan het verschil in y. A = (2, 3), B = (2, 8) → afstand = |8 − 3| = 5. Onthoud: afstand betekent verschil, niet som — en niet één van beide coördinaten.",
        "solutionSteps": [
          "A = (2, 3), B = (2, 8)",
          "Zelfde x-coördinaat (2) → punten op één verticale lijn",
          "Afstand = |8 − 3| = 5"
        ],
        "distractorExplanations": {
          "0": "Je hebt waarschijnlijk een rekenfout gemaakt: 8 − 3 = 5, niet 6. Onthoud: trek de y-coördinaten zorgvuldig van elkaar af.",
          "1": "Je hebt de y-coördinaten opgeteld: 8 + 3 = 11. Maar afstand betekent verschil, niet som. Reken: 8 − 3 = 5. Onthoud: afstand = aftrekken.",
          "2": "Goed! |8 − 3| = 5 eenheden.",
          "3": "Je hebt y = 3 (de y-coördinaat van A) als afstand gegeven. Maar dat is een coördinaat, geen afstand. De afstand = |8 − 3| = 5."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "met.coord-afstand-rekenfout", "label": "Rekenfout bij afstand", "optionIndex": 0 },
          { "id": "met.coord-afstand-optellen", "label": "Coördinaten opgeteld i.p.v. afgetrokken", "optionIndex": 1 },
          { "id": "met.coord-afstand-coordinaat-i.p.v.-verschil", "label": "Coördinaat als afstand", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "MET-COORDINATEN-006",
      "familyId": "MET-COORDINATEN",
      "module": "Metriek",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "figuren",
      "subSkill": "coordinaten_assenstelsel",
      "questionType": "fill_in",
      "question": "Een tuinontwerper plaatst een boom op punt (5, 2). Die boom schuift 4 hokjes naar rechts. Wat zijn de nieuwe coördinaten? Typ als (x, y), bijv. (9, 2).",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["(9, 2)", "(9,2)", "9, 2", "9,2"],
        "caseSensitive": false,
        "placeholder": "(?, ?)"
      },
      "stimulusAids": [
        {
          "type": "coordinateGrid",
          "data": {
            "width": 11,
            "height": 5,
            "showGrid": true,
            "points": [{ "x": 5, "y": 2, "label": "boom" }],
            "label": "Assenstelsel met boom op (5, 2)"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Verschuiving op de x-as",
            "content": "Naar rechts = x wordt groter, y blijft gelijk. (5, 2) → 4 naar rechts → (5 + 4, 2) = (9, 2).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "coordinates_translate_fill",
      "variantIndex": 6,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "Naar rechts schuiven verandert alleen de x-coördinaat: x = 5 + 4 = 9. De y blijft gelijk: y = 2. Nieuwe coördinaten: (9, 2). Onthoud: alleen horizontale beweging → alleen x verandert.",
        "solutionSteps": [
          "Beginpositie: (5, 2)",
          "4 naar rechts → x = 5 + 4 = 9",
          "y verandert niet (geen beweging omhoog/omlaag): y = 2",
          "Nieuwe positie: (9, 2)"
        ]
      },
      "pedagogy": {
        "dok": 2
      }
    }
  ]
}
